import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'

export const SectionError = ({ sectionName }: { sectionName: string }) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        gap: 8,
        backgroundColor: colors.red100,
        border: `1px solid ${colors.red200}`,
      }}
    >
      <div css={{ fontSize: 14, fontWeight: 'bold', color: colors.strongRed }}>
        {translate.phrases.banyanApp('Failed to load {{sectionName}}', { sectionName })}
      </div>
    </div>
  )
}
